module.exports = __webpack_public_path__ + "static/22_tat12-2c394d4a2eeecf67f5e48da330039538.jpg";